<ng-template let-group="group" let-subgroup="subgroup" let-association="association" #associationlabel>
	@if (group.action !== "delete") {
		<i
			class="ico"
			[ngClass]="
				association.isCommentOnly
					? getCommentAssociationIconClasses(association)
					: association.targetElement.dependent
						? getIconClasses(association.targetElement.parent)
						: getIconClasses(association.targetElement)
			"
		></i>
	}
	<div class="text" [ngClass]="getLabelClasses(association.sourceElement, association.targetElement)">
		<h4>
			@if (association.isCommentOnly) {
				{{ association.comment }}
				@if (association.sourceElement?.dependent) {
					<p>
						<ng-container
							*ngTemplateOutlet="
								dependentLabelAndIcon;
								context: {
									element: association.sourceElement,
								}
							"
						></ng-container>
					</p>
				}
			}
			@if (!association.isCommentOnly) {
				{{ getTargetElementLabel(association.targetElement) }}
			}
			@if (hasProcessInterfaceIcon(association)) {
				<i
					[ngClass]="getProcessInterfaceIconClasses(association)"
					title="{{ 'process.element.associationList.processInterfaceIconTitle' | translate }}"
					attr.aria-label="{{ 'process.element.associationList.processInterfaceIconTitle' | translate }}"
				></i>
			}
		</h4>
		@if (association.targetElement?.dependent || association.sourceElement?.dependent) {
			<p>
				@if (association.sourceElement?.dependent && group.groupBy !== "source") {
					<ng-container
						*ngTemplateOutlet="
							dependentLabelAndIcon;
							context: {
								element: association.sourceElement,
							}
						"
					></ng-container>
				}
				@if (association.targetElement?.dependent) {
					<ng-container
						*ngTemplateOutlet="
							dependentLabelAndIcon;
							context: {
								element: association.targetElement,
							}
						"
					></ng-container>
				}
			</p>
		}
		@if (showProcessInterfaceName() && association.isProcessInterface) {
			@if (!association.combined) {
				<p>
					{{ association.targetElement?.process.workspaceName }}
				</p>
			}
		}
		@if (association.combined) {
			<p translate="process.element.associationList.fromMultipleWorkspaces"></p>
		}
		@if (!isCommentInputAssociation(association, subgroup) && !association.isCommentOnly) {
			@if (!association.changeMarker || association.changeMarker.added || association.changeMarker.deleted) {
				<p>
					{{ association.comment }}
				</p>
			} @else {
				<p [innerHTML]="association.changeMarker.comment"></p>
			}
		}
		@if (association.changeMarker && association.changeMarker.added) {
			<p>
				<span class="badge added-badge" translate="process.compare.added"></span>
			</p>
		}
		@if (association.changeMarker && association.changeMarker.deleted) {
			<p>
				<span class="badge deleted-badge" translate="process.compare.deleted"></span>
			</p>
		}
	</div>
</ng-template>

<ng-template
	let-group="group"
	let-subgroup="subgroup"
	let-association="association"
	let-expandableGroup="expandableGroup"
	let-sourceElement="sourceElement"
	#associationTemplate
>
	@if (group.action === "delete") {
		<div class="select">
			<input
				type="checkbox"
				class="checkbox"
				[(ngModel)]="group.selection!.set[association.id]"
				(ngModelChange)="group.selection!.onChange(association)"
				[disabled]="!isSelectable(association)"
				id="a{{ group.id }}{{ association.id }}"
			/>
			<label for="a{{ group.id }}{{ association.id }}"></label>
		</div>
	}
	@if (
		!association.isCommentOnly &&
		!isCommentInputAssociation(association, subgroup) &&
		!association.combined &&
		!(association.changeMarker && association.changeMarker.deleted)
	) {
		<a class="label" [routerLink]="getTargetElementLink(association)">
			<ng-container
				*ngTemplateOutlet="associationlabel; context: { group: group, subgroup: subgroup, association: association }"
			></ng-container>
		</a>
	}
	@if (association.combined) {
		<a class="label clickable" (click)="openDetailViewOfCombined(association, group, sourceElement)">
			<ng-container
				*ngTemplateOutlet="associationlabel; context: { group: group, subgroup: subgroup, association: association }"
			></ng-container>
		</a>
	}
	@if (
		!association.isCommentOnly &&
		!isCommentInputAssociation(association, subgroup) &&
		!association.combined &&
		association.changeMarker &&
		association.changeMarker.deleted
	) {
		<div class="label">
			<ng-container
				*ngTemplateOutlet="associationlabel; context: { group: group, subgroup: subgroup, association: association }"
			></ng-container>
		</div>
	}
	@if (!association.isCommentOnly && isCommentInputAssociation(association, subgroup)) {
		<div class="label" id="comment-editor-{{ association.id }}">
			<i
				class="ico"
				[ngClass]="
					association.targetElement.dependent
						? getIconClasses(association.targetElement.parent)
						: getIconClasses(association.targetElement)
				"
			></i>
			<div class="text">
				<h4>
					{{ getTargetElementCombinedLabel(association.targetElement) }}
					@if (hasProcessInterfaceIcon(association)) {
						<i
							[ngClass]="getProcessInterfaceIconClasses(association)"
							title="{{ 'process.element.associationList.processInterfaceIconTitle' | translate }} "
						></i>
					}
				</h4>
				<input
					class="comment"
					type="text"
					[placeholder]="'editComment.placeholder' | translate"
					[(ngModel)]="commentInputText"
					(blur)="hideCommentInput()"
					(stagesKeyUp)="onCommentInputKeyUp($event, association)"
					stagesAutofocus
				/>
			</div>
		</div>
	}
	@if (association.isCommentOnly && !association.combined) {
		<div class="label comment-only">
			<!--
          TODO: Include/merge this case in/with associationLabel template
          <ng-container
            *ngTemplateOutlet="associationlabel; context: { group: group, subgroup: subgroup, association: association }"
          ></ng-container>-->
			@if (group.action !== "delete") {
				<i class="ico comment" [ngClass]="getCommentAssociationIconClasses(association)"></i>
			}
			<div class="text">
				@if (!isCommentInputAssociation(association, subgroup)) {
					@if (!association.changeMarker || association.changeMarker.added || association.changeMarker.deleted) {
						<h4>
							{{ association.comment }}
							@if (hasProcessInterfaceIcon(association)) {
								<i
									[ngClass]="getProcessInterfaceIconClasses(association)"
									title="{{ 'process.element.associationList.processInterfaceIconTitle' | translate }}"
									attr.aria-label="{{ 'process.element.associationList.processInterfaceIconTitle' | translate }}"
								></i>
							}
						</h4>
					} @else {
						<h4 [innerHTML]="association.changeMarker.comment"></h4>
					}
					@if (association.sourceElement?.dependent && group.groupBy !== "source") {
						<p>
							<ng-container
								*ngTemplateOutlet="
									dependentLabelAndIcon;
									context: {
										element: association.sourceElement,
									}
								"
							></ng-container>
						</p>
					}
				}
				@if (isCommentInputAssociation(association, subgroup)) {
					<div id="comment-editor-{{ association.id }}" class="label">
						<input
							class="comment"
							type="text"
							[placeholder]="'editComment.placeholder' | translate"
							(blur)="hideCommentInput()"
							[(ngModel)]="commentInputText"
							(stagesKeyUp)="onCommentInputKeyUp($event, association)"
							stagesAutofocus
						/>
					</div>
				}
				@if (showProcessInterfaceName() && association.isProcessInterface) {
					@if (!association.combined) {
						<p>
							{{ association.targetWorkspaceName }}
						</p>
					}
				}
				@if (association.changeMarker && association.changeMarker.added) {
					<p>
						@if (association.changeMarker.added) {
							<span class="badge added-badge" translate="process.compare.added"></span>
						}
					</p>
				}
				@if (association.changeMarker && association.changeMarker.deleted) {
					<p>
						@if (association.changeMarker.deleted) {
							<span class="badge deleted-badge" translate="process.compare.deleted"></span>
						}
					</p>
				}
			</div>
		</div>
	}
	@if (showMenu) {
		<stages-menu
			class="action"
			[context]="{ association: association, group: group, subgroup: subgroup, expandableGroup: expandableGroup }"
			menuId="assocMenu{{ association.id }}"
			iconClasses="ico ico-more-vertical"
			openTo="left"
			[items]="associationMenuItems"
		/>
	}
</ng-template>

@if (!visibleGroups.length) {
	<p class="empty" translate="{{ messageKeyNone() }}"></p>
}
@if (visibleGroups.length) {
	<ul class="grouped-list">
		@for (group of visibleGroups; track trackById($index, group)) {
			<li class="group" [id]="group.id" [ngClass]="getGroupStyleClasses(group)" [hidden]="!group.visible">
				<header class="group-header">
					<div class="list-header-with-counter">
						@if (group.translate) {
							<h3 (click)="toggle(group)" [translate]="group.translate"></h3>
						} @else {
							<h3 (click)="toggle(group)">{{ group.name }}</h3>
						}
						<span class="counter">{{ getAssociationsCount(group) }}</span>
					</div>
					<stages-button-expand-collapse
						class="action menu-button"
						[isCollapsed]="!group.expand"
						(pressedButton)="toggle(group)"
					>
					</stages-button-expand-collapse>
					@if (hasAnyAssociations(group)) {
						<stages-menu
							[context]="group"
							menuId="assocGroupMenu{{ group.id }}"
							class="action"
							iconClasses="ico ico-more-vertical"
							openTo="left"
							[items]="associationGroupMenuItems"
						></stages-menu>
					}
				</header>
				<div class="relative-container">
					<div class="animation-container">
						<div
							#expandableGroup
							[@expandCollapseFromTop]="getExpandCollapseFromTop(group, expandableGroup)"
							class="expandable"
							(@expandCollapseFromTop.done)="doneExpandCollapse($event, group)"
							[ngClass]="group.expand ? 'expand' : 'collapse'"
						>
							@if (group.action === "add" || group.action === "changeTarget" || group.action === "changeSource") {
								<div class="button-bar" (click)="preventClosingAdd($event)">
									<div class="buttons">
										<button class="sm cancel" (click)="closeEdit(group)" translate="cancel"></button>
										@if (!associationToChange) {
											<button class="sm prime" (click)="browse(group)" translate="browse" stages-scroll="keep"></button>
										}
									</div>
									@if (group.action !== "changeSource") {
										<stages-add-target-element
											[associationStore]="associationStore()"
											[sourceElementTypedId]="
												sourceElementForAdd
													? asTypedId(sourceElementForAdd)
													: { id: sourceElementForChange!.id, typeIdent: sourceElementForChange!.type.ident }
											"
											[sourceElement]="sourceElementForAdd ?? sourceElementForChange!"
											[sourceRole]="group.sourceRole"
											[targetElementWorkspace]="getTargetSearchWorkspaceId(group)"
											[targetElementType]="group.targetType!"
											[targetElementSubtypes]="group.targetSubtypes!"
											[targetElementParentId]="group.targetElementParentId"
											[targetElementProcessIds]="
												associationToChange
													? [associationToChange.targetElement!.process.id]
													: targetElementProcessIds()
											"
											[targetElementCreateAllowed]="group.targetElementCreateAllowed"
											[commentOnlyAssociationsAllowed]="group.commentOnlyAssociationsSupported"
											[targetElementsToIgnore]="getTargetElementsToIgnore(group)"
											[associationType]="group.type"
											[remoteWorkspaceSeparatorInAutocomplete]="remoteWorkspaceSeparatorInAutocomplete()"
											[restrictAssociateDependentElementTypes]="getDependentElementTypesRestrictions(group)"
											[path]="group.path"
											[sourceAssociation]="associationToChange"
											(addedAssociation)="associationAdded($event, group.id)"
											(associationToCreate)="associationUpdated($event, group.id)"
											(cancelled)="closeEdit(group)"
										>
										</stages-add-target-element>
									}
									@if (group.action === "changeSource") {
										<stages-change-source-element
											[sourceElementContainer]="container().sourceElement"
											[associationToChange]="associationToChange!"
											[associationType]="group.type"
											[existingAssociations]="group.list"
											[sourceRole]="group.sourceRole"
											[restrictAssociateDependentElementTypes]="[dependentSubtypeIdentForChange!]"
											[associationStore]="associationStore()"
											[path]="group.path"
											(addedCallback)="associationAdded($event, group.id)"
											(cancelled)="closeEdit(group)"
										>
										</stages-change-source-element>
									}
								</div>
							}
							@if (group.action === "delete" || group.action === "sort") {
								<stages-buttons-responsive>
									@if (group.action === "delete") {
										<button class="sm cancel" (click)="closeEdit(group)" translate="cancel"></button>
										<button
											class="sm delete"
											(click)="deleteAssociations(group)"
											[disabled]="isSaveInProgress || !group.selection!.isSomeSelected()"
										>
											@if (!isSaveInProgress) {
												<span translate="remove"></span>
											}
											@if (isSaveInProgress) {
												<stages-spin size="s"></stages-spin>
											}
										</button>
									}
									@if (group.action === "sort") {
										<button class="sm cancel" (click)="onCancel(group)" translate="cancel"></button>
										<button
											class="button sm save sort"
											type="submit"
											name="submit"
											[disabled]="isSaveInProgress || !sortOrderWasChanged"
											(click)="saveSortedAssociations(group)"
										>
											@if (!isSaveInProgress) {
												<span translate="rearrange"></span>
											}
											@if (isSaveInProgress) {
												<stages-spin size="s"></stages-spin>
											}
										</button>
									}
								</stages-buttons-responsive>
							}
							@if (group.action === "sort") {
								<div class="sort-selection-box">
									<div class="select"></div>
									<div class="label">
										<select
											name="order"
											id="order"
											(change)="onOrderChange($any($event.target).value, group)"
											class="fullsize"
										>
											<option
												value="ALPHABETICAL"
												translate="rearrange.order.az"
												[selected]="getActualSortStrategy(group) === 'ALPHABETICAL'"
											></option>
											<option
												value="CUSTOM"
												translate="rearrange.order.custom"
												[selected]="getActualSortStrategy(group) === 'CUSTOM'"
											></option>
											<option
												value="HIERARCHICAL"
												translate="rearrange.order.hierarchical"
												[selected]="getActualSortStrategy(group) === 'HIERARCHICAL'"
											></option>
										</select>
									</div>
								</div>
							}
							<div #scrollContainer>
								<ul
									#assocList
									cdkDropList
									(cdkDropListDropped)="drop($event, group)"
									[cdkDropListDisabled]="group.action !== 'sort'"
									class="list dense"
									[ngClass]="{ selectable: group.action === 'delete' }"
								>
									@for (subgroup of group.subgroups; track subgroup) {
										<li class="group subgroup" [style.display]="subgroup.visible ? 'block' : 'none'">
											<header class="group-header">
												<h4
													[style.text-decoration]="subgroup.tailored ? 'line-through' : 'none'"
													(click)="toggleSubgroup(subgroup, group)"
												>
													{{ subgroup.name }}
												</h4>
												<span class="counter">{{ subgroup.list.length }}</span>
												<stages-button-expand-collapse
													class="action menu-button"
													[isCollapsed]="!subgroup.expand"
													[ngClass]="hasAnyEnabledGroupMenuItems(group) ? 'right-indent' : ''"
													(pressedButton)="toggleSubgroup(subgroup, group)"
												>
												</stages-button-expand-collapse>
											</header>
											<div class="animation-container">
												<div
													#expandableSubgroup
													[@expandCollapseFromTop]="getExpandCollapseFromTop(group, expandableSubgroup, subgroup)"
													class="expandable"
													[ngClass]="subgroup.expand ? 'expand' : 'collapse'"
												>
													<!-- see https://youtrack.jetbrains.com/issue/WEB-72984/Angular-error-with-boolean-inputs-with-generic-directive -->
													<!-- @ts-expect-error TS2322: Type 'boolean' is not assignable to type 'typeof CdkDropList<T>' -->
													<ul
														#assocList
														cdkDropList
														(cdkDropListDropped)="dropSubgroup($event, group, subgroup)"
														[cdkDropListDisabled]="group.action !== 'sort'"
														class="list dense subgroup-list"
													>
														@for (association of subgroup.visibleList; track trackById($index, association)) {
															<li #assocListItem cdkDragLockAxis="y" cdkDrag class="list-item">
																<div class="dragged-item-placeholder" *cdkDragPlaceholder></div>
																@if (group.action === "sort") {
																	<div class="handle draggableAreaForSort">
																		<i class="ico ico-handle"></i>
																	</div>
																}
																<ng-container
																	*ngTemplateOutlet="
																		associationTemplate;
																		context: {
																			group: group,
																			subgroup: subgroup,
																			association: association,
																			expandableGroup: expandableGroup,
																			sourceElement: container().sourceElement,
																		}
																	"
																></ng-container>
															</li>
														}
														@if (hasMoreInSubgroup(subgroup)) {
															<li class="list-item">
																<a class="label clickable" (click)="loadMoreIntoSubgroup(subgroup)">
																	<div class="text center">
																		<span class="show-more center" translate="more"></span>
																	</div>
																</a>
															</li>
														}
													</ul>
												</div>
											</div>
										</li>
									}
									@for (association of group.visibleList; track trackById($index, association)) {
										<li class="list-item" cdkDrag cdkDragLockAxis="y">
											<div class="dragged-item-placeholder" *cdkDragPlaceholder></div>
											@if (group.action === "sort") {
												<div class="handle draggableAreaForSort">
													<i class="ico ico-handle"></i>
												</div>
											}
											<ng-container
												*ngTemplateOutlet="
													associationTemplate;
													context: {
														group: group,
														association: association,
														expandableGroup: expandableGroup,
														sourceElement: container().sourceElement,
													}
												"
											></ng-container>
										</li>
									}
									@if (hasMore(group)) {
										<li class="list-item">
											<a class="label clickable" (click)="loadMore(group)">
												<div class="text center">
													<span class="show-more center" translate="more"></span>
												</div>
											</a>
										</li>
									}
								</ul>
							</div>
						</div>
					</div>
				</div>
			</li>
		}
	</ul>
}

<ng-template #dependentLabelAndIcon let-element="element">
	{{ element.label }}
	<i
		class="ico"
		[ngClass]="getIconClasses(element)"
		[title]="element.type.name"
		[attr.aria-label]="element.type.name"
	></i>
</ng-template>
